// extracted by mini-css-extract-plugin
module.exports = {"pricePart":"ProductCard_pricePart__NBCoN"};